import { Component, ElementRef, HostListener, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy, SimpleChanges, OnChanges } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as projectsetup from '../projectmanagement.form';

import { ProjectmanagementService } from '../../service/projectmanagement.service';

import { MyErrorHandler } from '../../errorhandler/errorhandler';
import { Grade, Year, Class, Subject } from '../../../../../schoolmanagement/src/app/model/school.model';
import * as _ from 'underscore';
import { Observable, Subscription } from 'rxjs';
declare var jQuery;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-prj-grade-form',
  templateUrl: './ctl.project.grade.component.html',
  styleUrls: ['./ctl.project.grade.component.css'],
  providers: [ProjectmanagementService]
})


export class ProjectGradeComponent implements OnInit, OnChanges {

  loaded = false;
  // gradeYearForm: FormGroup;

  @Input() projectData: any;
  @Input() type: string;
  @Input() myFormGroup: FormGroup;
  @Input() myGradeList: Grade[] = [];
  @Input() myYearList: Year[] = [];
  @Input() mygradecheckArr = [];
  @Input() cancelClicked : Observable<void>;
  @Output() evRemoveGrade: EventEmitter<number> = new EventEmitter();
  @Output() evBtnStatus: EventEmitter<boolean> = new EventEmitter();

  private eventsSubscription: Subscription;
  school_id: string;
  year: string;
  grade_id: string;
  yearList: Year[] = [];
  gradeState = '';
  gradeDataList = [];
  row = [];
  finrow = 0;
  blankItemIndex = 0;
  isEdited = 0;
  absYearList: Year[] = [];
  nextBtnDisabled = true;
  yearSelected = false;
  gradeName = '';
  yearSelectConfig:any;
  
  textDir:any;
  constructor(
    private _fb: FormBuilder,
    public translate: TranslateService,
    private projectService: ProjectmanagementService,
    private router: Router,
    private route: ActivatedRoute) {
      this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    this.eventsSubscription = this.cancelClicked.subscribe(() => {
      this.nextBtnDisabled = false;
    });
    this.translate.get('Select ref. year').subscribe((translated: string) => {
      this.yearSelectConfig = {
        placeholder: translated,
        displayKey: 'name',
        search: false,
        height: '150px',
        customComparator: (function compare(a, b) {
          if (a.number < b.number) {
            return -1;
          }
          if (a.number > b.number ) {
            return 1;
          }
          // a must be equal to b
          return 0;
        })
      };
    });
    this.gradeState =  this.route.snapshot.url[0].path;
    this.isEdited = 0;
    if (this.gradeState === 'view'){
      this.nextBtnDisabled = false;
    }
    if (this.gradeState === 'setup'){      
        setTimeout(() => {  
          if(this.myFormGroup.controls['gradeArray']['controls'][0]){        
            if(this.myFormGroup.controls['gradeArray']['controls'][0].value.name != '' && this.myFormGroup.controls['gradeArray']['controls'][0].value.year.name != ''){
              this.nextBtnDisabled = false;
            }
          }
        }, 1000);           
    }
  }

  log(val) { console.log(val); }

  ngOnChanges(changes: SimpleChanges) {
    //
    if (typeof changes.myYearList !== 'undefined') {

      // retrieve the quiz variable change info
      const change = changes.myYearList;
      // only perform the task if the value has been changed
      if (!change.isFirstChange()) {
        this.myYearList.slice(0).forEach( value => {
          value.name = value.name + ' (' + value?.description + ')';
         // alert("value changes")
        });

        this.yearList = this.myYearList.slice(0);
        this.absYearList = this.myYearList.slice(0);
        const control = this.myFormGroup.controls.gradeArray  as FormArray;
        this.clearFormArray(control);
        this.addGradesToForm(this.yearList);
      }
    }
  }

  clearFormArray(formArray: FormArray){
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }
  gradeChange($event){
    this.gradeName = $event.target.value;
    if (this.gradeName.length > 0 && this.yearSelected){
      this.nextBtnDisabled = false;
      this.evBtnStatus.emit(this.nextBtnDisabled);
    }
  }
  modifyYearList(data){
    if (typeof data.value !== 'undefined'){
      this.yearList.forEach((yr, index) => {
        if (yr._id === data.value._id){
          this.yearList.splice(index, 1);
          /* TODO: Need to find better solution. */
          if (!_.isEqual(this.myYearList, this.yearList)){
            this.myYearList.splice(index, 1);
          }
        }
      });
      if (data.value){
        this.yearSelected = true;
      }
      if (this.gradeName.length > 0 && this.yearSelected){
        this.nextBtnDisabled = false;
        this.evBtnStatus.emit(this.nextBtnDisabled);
      }
    }
    this.generateBlankItemIndex();
  }

  regenerateYearList(){
    this.yearList.splice(0);
    this.absYearList.forEach((yr) => {
      this.yearList.push(yr);
      this.myFormGroup.controls.gradeArray.value.forEach((inputYr) => {
        if (_.isEqual(yr._id, inputYr.year._id)){
          this.yearList.pop();
        }
      });
    });
  }
  generateBlankItemIndex(){
    this.isEdited = 1;
    const frmControl = this.myFormGroup.controls.gradeArray  as FormArray;
    for (let i = 0; i < frmControl.length; i++){
      const gradeDataArr = frmControl.at(i);
      if (gradeDataArr.value.name === '' && gradeDataArr.value.year === ''){
        this.blankItemIndex = i;  
             
        return;
      }else{        
        this.blankItemIndex = i + 1;
      }
    }
  }
  addGradesToForm(years: Year[]) {
    this.loaded = false;
    this.row = [];
    const control = this.myFormGroup.controls.gradeArray  as FormArray;
    // const removeArr = [];
    const removeArr1 = [];

    let gradeDataList;
    if (this.myGradeList){
      gradeDataList = this.myGradeList.slice(0);
    }
    let j = 0;
    years.forEach(element => {
      if (gradeDataList && gradeDataList[0] && Object.keys(gradeDataList[0]).length) {
        let i = 0;
        let flag = false;
        for (const grade of gradeDataList) {
          if (grade.year && grade.year._id === element._id) {
            if (grade.year.name.indexOf('(') === -1){
              grade.year.name = grade.year.name + ' (' + grade.year.description + ')';
            }
            control.push(this.patchGrade(grade.name, grade.year, grade._id));
            gradeDataList.splice(i, 1);
            this.row[j] = true;
            this.finrow = j;
            flag = true;

            /* Remove year those are already present */
            this.yearList.forEach((yr, index) => {
              if (_.isEqual(yr._id, grade.year._id) && yr._id !== ''){
                jQuery.grep(this.yearList, ( n, i ) => {
                  if (n._id === yr._id){
                    // removeArr.push(i);
                    removeArr1.push(n);
                  }
                });
              }
            });

            break;
          }
          i++;
        }
        if (flag === false) {
          control.push(this.patchGrade('', ''));
        }
      } else {
        if (j === 0){
          this.row[j] = true;
        }else{
           this.row[j] = false;
        }
        control.push(this.patchGrade('', ''));
      }
      j++;
    });
    let prev = 0;

    /*removeArr.forEach((item, iter) => {
      if (iter === 0){
        this.yearList.splice(item, 1);
      }else if (iter > 0){
        this.yearList.splice((item - prev) - 1, 1);
      }
      prev = item;
    });*/

    removeArr1.forEach((item, iter) => {
      this.yearList.splice(this.yearList.findIndex(x => x._id === item._id), 1);
    });

    
    this.loaded = true;
    this.generateBlankItemIndex();    
  }
  removeGrade(i)
  {
    const control = this.myFormGroup.controls.gradeArray as FormArray;
    /*this.row[i]=false;
    control[i]=this.patchGrade('', this.myYearList[i]);
    //this.myFormGroup.controls.gradeArray.get(i).value.get('name').patchValue('');*/
   
    this.myFormGroup.controls['gradeArray']['controls'][i].patchValue({name: '', year: ''});
    this.row[i] = false;
    const id = this.myFormGroup.controls['gradeArray']['controls'][i].value.grade_id;

    const obj = {id: '', index: ''};
    obj.id = this.myFormGroup.controls['gradeArray']['controls'][i].value.grade_id;
    obj.index = i;

    this.evRemoveGrade.emit(i);

    let j;
    let k;
    for ( j = 0 ; j <= 11; j++){
      if (this.row[j] === true){
        k = j;
      }
    }
    this.finrow = k;
    this.regenerateYearList();
    
    if(this.myFormGroup.controls.gradeArray.value[0].name.length == 0){
      this.nextBtnDisabled = true;
      this.evBtnStatus.emit(this.nextBtnDisabled); 
    }else{
      this.nextBtnDisabled = false;
      this.evBtnStatus.emit(this.nextBtnDisabled);  
    }
     
    this.generateBlankItemIndex();
    this.isEdited = 0;
    
  }
  addGrade(i){
    this.nextBtnDisabled = true;
    this.evBtnStatus.emit(this.nextBtnDisabled);
    this.yearSelected = false;
    this.generateBlankItemIndex();
    this.row[i] = true;
    let j;
    let k;
    for ( j = 0 ; j <= 11; j++){
      if (this.row[j] === true){
        k = j;
      }
    }
    this.finrow = k;
  }

  patchGrade(name, year, grade_id?, classes?) {
    return this._fb.group({
      name: [name],
      year: [year],
      grade_id:[grade_id]
    });
  }
  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }
}
